// Core Imports
import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

// Module Imports
import { periodEndpoints } from '@/modules/period/period.constants'
import type {
  TCreatePeriodRequest,
  TPeriod,
  TPeriodOption,
  TUpdatePeriodRequest,
} from '@/modules/period/period.types'

export async function getPeriodList(
  page: number,
  query: string,
  status?: string
): Promise<TResponse<TPeriod[]>> {
  const res = await api.get<TResponse<TPeriod[]>>(
    periodEndpoints.list(page, query, status)
  )
  return res.data
}

export async function getPeriodDetail(id: string): Promise<TPeriod> {
  const res = await api.get<TResponse<TPeriod>>(periodEndpoints.detail(id))
  return res.data.data
}

export async function getPeriodOptions(): Promise<TPeriodOption[]> {
  const res = await api.get<TResponse<TPeriodOption[]>>(periodEndpoints.options)
  return res.data.data
}

export async function createPeriod(
  body: TCreatePeriodRequest
): Promise<TPeriod> {
  const res = await api.post<TResponse<TPeriod>>(periodEndpoints.create, body)
  return res.data.data
}

export async function updatePeriod(
  id: string,
  body: TUpdatePeriodRequest
): Promise<TPeriod> {
  const res = await api.patch<TResponse<TPeriod>>(
    periodEndpoints.update(id),
    body
  )
  return res.data.data
}

export async function activatePeriod(id: string): Promise<void> {
  await api.post(periodEndpoints.activate(id))
}

export async function passivePeriod(id: string): Promise<void> {
  await api.post(periodEndpoints.passive(id))
}

export async function deletePeriod(id: string): Promise<void> {
  await api.delete(periodEndpoints.remove(id))
}
